<div class="fc-text-input">
  <div class="fc-text-input__prefix" (click)="input.focus()" *ngIf="showSearchIcon">
    <mat-icon>search</mat-icon>
  </div>
  <div class="fc-text-input__infix" [class.float-label]="control.value" [class.search-icon-hidden]="!showSearchIcon">
    <label class="fc-text-input__infix-label">{{ label }}<span *ngIf="requiredMark">*</span></label>
    <input class="fc-text-input__infix-input" #input [formControl]="control" />
  </div>
  <small class="fc-text-input__infix-hint" *ngIf="hint">
    {{ hint }}
  </small>
  <mat-progress-bar class="fc-text-input__progress" *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>
</div>
